module.exports = __webpack_public_path__ + "static/media/bg_01.b78e8739.jpg";